export default __webpack_public_path__ + "static/media/RotateRight.d4c11c17.svg";